// extracted by mini-css-extract-plugin
export default {"tupacGrid":"lm-z","tupacHeader":"mm-z","tupacHeader2":"nm-z","tupacMenu":"om-z","tupacMenu2":"pm-z","tupacMain":"qm-z","tupacMain2":"rm-z"};